import React from 'react'
import {Link} from 'react-router-dom'
import {SITE_NAME} from '../constants'
export function NavbarBrand() {
  return <div className="navbar-brand">
    <Link to="/" > <h4 style={{lineHeight:1.9}}>{SITE_NAME}</h4></Link>
  </div>
}

export function CenterTitle() {
  return <div>
      <Link to="/" style={{textDecoration:'none'}}> <h3 className="text-center" style={{lineHeight:1.9}}>{SITE_NAME}</h3></Link>
  </div>
}



// WEBPACK FOOTER //
// ./src/components/header.js